import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../index";
import { getAuthToken } from "../../utils/utils";

export const fetchPublicPricing = createAsyncThunk(
  "pricing/fetchPublic",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${baseUrl}/api/pricing`);
      return res.data.pricing;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch pricing");
    }
  }
);

export const fetchAdminPricing = createAsyncThunk(
  "pricing/fetchAdmin",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${baseUrl}/admin/pricing`, {
        headers: { Authorization: token },
      });
      return res.data.pricing;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch pricing");
    }
  }
);

export const updateAdminPricing = createAsyncThunk(
  "pricing/update",
  async ({ monthlyPrice, yearlyPrice }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.put(
        `${baseUrl}/admin/pricing`,
        { monthlyPrice, yearlyPrice },
        { headers: { Authorization: token } }
      );
      return res.data.pricing;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to update pricing");
    }
  }
);

const pricingSlice = createSlice({
  name: "pricing",
  initialState: {
    pricing: null,
    loading: false,
    saving: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearPricingMessages(state) {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicPricing.pending, (state) => { state.loading = true; })
      .addCase(fetchPublicPricing.fulfilled, (state, action) => {
        state.loading = false;
        state.pricing = action.payload;
      })
      .addCase(fetchPublicPricing.rejected, (state) => { state.loading = false; })

      .addCase(fetchAdminPricing.pending, (state) => { state.loading = true; })
      .addCase(fetchAdminPricing.fulfilled, (state, action) => {
        state.loading = false;
        state.pricing = action.payload;
      })
      .addCase(fetchAdminPricing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateAdminPricing.pending, (state) => { state.saving = true; state.error = null; state.successMessage = null; })
      .addCase(updateAdminPricing.fulfilled, (state, action) => {
        state.saving = false;
        state.pricing = action.payload;
        state.successMessage = "Pricing updated and all users notified by email.";
      })
      .addCase(updateAdminPricing.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });
  },
});

export const { clearPricingMessages } = pricingSlice.actions;
export default pricingSlice.reducer;
